var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../../../log';
import { Sutl } from '../../../../sutl';
import { WorkTokenSource } from './WorkToken';
const log = Log.channel('WorkTokenQueue');
export class WorkTokenQueue {
    constructor() {
        this.requests = [];
    }
    get isWorking() {
        return this.requests.length > 0 || this.currentRequest !== undefined;
    }
    set onCancelled(fn) {
        this._onCancelled = fn;
    }
    set onCompleted(fn) {
        this._onCompleted = fn;
    }
    set onGranted(fn) {
        this._onGranted = fn;
    }
    set onRequested(fn) {
        this._onRequested = fn;
    }
    cancelAll() {
        var _a, _b;
        for (const request of this.requests) {
            (_a = this._onCancelled) === null || _a === void 0 ? void 0 : _a.call(this, request.token, request.info);
            request.token.cancel();
        }
        this.requests.length = 0;
        if (this.currentRequest) {
            (_b = this._onCancelled) === null || _b === void 0 ? void 0 : _b.call(this, this.currentRequest.token, this.currentRequest.info);
            this.currentRequest.token.cancel();
        }
    }
    cancelSome(shouldCancel) {
        var _a;
        Sutl.filterInPlace(this.requests, (request) => {
            var _a;
            if (shouldCancel(request.info, false)) {
                (_a = this._onCancelled) === null || _a === void 0 ? void 0 : _a.call(this, request.token, request.info);
                request.token.cancel();
                return false;
            }
            return true;
        });
        if (this.currentRequest !== undefined && shouldCancel(this.currentRequest.info, true)) {
            (_a = this._onCancelled) === null || _a === void 0 ? void 0 : _a.call(this, this.currentRequest.token, this.currentRequest.info);
            this.currentRequest.token.cancel();
        }
    }
    handleNextRequest() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentRequest !== undefined)
                return;
            this.currentRequest = this.requests.shift();
            while (this.currentRequest !== undefined) {
                const currentRequest = this.currentRequest;
                // TODO: use waitFor when converting to sutl2
                let subscription;
                const complete = new Promise((resolve, reject) => {
                    subscription = currentRequest.token.completed.subscribe(isCompleted => {
                        if (isCompleted)
                            resolve();
                    });
                });
                (_a = this._onGranted) === null || _a === void 0 ? void 0 : _a.call(this, currentRequest.token, currentRequest.info);
                currentRequest.resolve(this.currentRequest.token); // give token to consumer
                try {
                    yield complete; // wait for consumer to finish
                }
                catch (error) {
                    log.error(`uncaught error in work token: ${error}`);
                }
                (_b = this._onCompleted) === null || _b === void 0 ? void 0 : _b.call(this, currentRequest.token, currentRequest.info);
                subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
                this.currentRequest = this.requests.shift(); // get next request
            }
        });
    }
    requestToken(info) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                const token = new WorkTokenSource();
                (_a = this._onRequested) === null || _a === void 0 ? void 0 : _a.call(this, token, info);
                this.requests.push({ token, info, resolve, reject });
                if (this.currentRequest === undefined)
                    this.handleNextRequest();
            });
        });
    }
}
